import React, { useEffect, useState } from 'react';
import { ref, get } from 'firebase/database';
import { database } from '../firebaseConfig';
import PhoneInput from './PhoneInput';

const box = { width: '100%', padding: 10, border: '1px solid #d8c9a8', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' };

// Lets the agent pick a Lender partner or enter a lender by hand. Stored on the transaction as formData.lender.
export default function LenderSection({ value = {}, onChange }) {
  const [lenders, setLenders] = useState([]);

  useEffect(() => {
    get(ref(database, 'partners')).then((snap) => {
      const all = snap.exists() ? snap.val() : {};
      const list = Object.entries(all)
        .map(([id, p]) => ({ id, ...p }))
        .filter((p) => p.partnerType === 'Lender')
        .sort((a, b) => String(a.companyName || '').localeCompare(String(b.companyName || '')));
      setLenders(list);
    }).catch(() => setLenders([]));
  }, []);

  const set = (patch) => onChange({ ...value, ...patch });

  const pick = (choice) => {
    if (choice === 'other') return set({ partnerId: 'other' });
    const p = lenders.find((l) => l.id === choice);
    if (!p) return set({ partnerId: '' });
    set({ partnerId: p.id, companyName: p.companyName || '', firstName: p.firstName || '', lastName: p.lastName || '', email: p.email || '', phone: p.phone || '' });
  };

  const isOther = value.partnerId === 'other';

  return (
    <fieldset style={{ border: '1px solid #e5dcc8', borderRadius: 8, padding: 16, marginBottom: 16 }}>
      <legend style={{ fontWeight: 700, padding: '0 6px' }}>Lender</legend>
      <label style={{ display: 'block', fontSize: 14, marginBottom: 6 }}>Choose a lender</label>
      <select style={{ ...box, marginBottom: 12 }} value={value.partnerId || ''} onChange={(e) => pick(e.target.value)} required>
        <option value="">Select a lender</option>
        {lenders.map((l) => <option key={l.id} value={l.id}>{l.companyName || `${l.firstName || ''} ${l.lastName || ''}`.trim()}</option>)}
        <option value="other">Other</option>
      </select>
      {isOther && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12 }}>
          <input style={box} placeholder="Lender company name" value={value.companyName || ''} onChange={(e) => set({ companyName: e.target.value })} />
          <input style={box} placeholder="First name" value={value.firstName || ''} onChange={(e) => set({ firstName: e.target.value })} />
          <input style={box} placeholder="Last name" value={value.lastName || ''} onChange={(e) => set({ lastName: e.target.value })} />
          <input style={box} placeholder="Email" value={value.email || ''} onChange={(e) => set({ email: e.target.value })} />
          <PhoneInput style={box} placeholder="(239) 555-1234" value={value.phone || ''} onChange={(e) => set({ phone: e.target.value })} />
        </div>
      )}
    </fieldset>
  );
}
